<template>
    <div class="cash-withdrawal" style="padding-top: 1rem">
        <!--<navTitle title="佣金提现"></navTitle>-->
        <navTitle
                :title="$router.app._route.query.ti ? $router.app._route.query.ti : $t('message.promoter.user_cash_title')"></navTitle>
        <div class="nav acea-row">
            <div v-for="(item, index) in navList" class="item"
                    @click="swichNav(index, item)"
                    :key="index" :class="currentTab === index ? 'click' : ''">
                <div>{{ item.name }}</div>
            </div>
        </div>

        <div class="wrapper">
            <!--提现到电子钱包-->
            <div :hidden="currentTab !== 0" class="list" style="position: relative">
                <div class="isnull" v-if="showTips === 'true'" style="position: absolute">
                    {{$t('message.promoter.user_cash_not_link')}}
                    <div class="isnull-btn" @click="$router.push({ path: '/user/myPay' })">
                        {{$t('message.promoter.user_cash_link_now')}}
                    </div>
                </div>
                <div v-if="showTips === 'false'">
                    <div class="item acea-row row-between-wrapper">
                        <div class="name">TNH</div>
                        <div class="input">
                            <select v-model="cashId">
                                <option value="">{{$t('message.promoter.user_cash_select_account')}}</option>
                                <option v-for="(item, index) in cashList" :key="index" :value="item.id">{{ item.type===
                                    'BinancePay' ? $t('message.promoter.user_cash_binance_pay'):item.bank_name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="item acea-row row-between-wrapper">
                        <div class="name">STNH</div>
                        <div class="input">
                            <input readonly :placeholder="$t('message.promoter.user_cash_bank_account_pla')"
                                   v-model="post.bank_account"/>
                        </div>
                    </div>
                    <!--<div class="item acea-row row-between-wrapper">
                        <div class="name">IFSC</div>
                        <div class="input">
                            <input readonly :placeholder="$t('message.promoter.user_cash_ifsc_pla')"
                                   v-model="post.ifsc"/>
                        </div>
                    </div>-->
                    <div class="item acea-row row-between-wrapper">
                        <div class="name">{{$t('message.promoter.user_cash_withdraw')}}</div>
                        <div class="input">
                            <input :placeholder="$t('message.promoter.user_cash_minimum')+' '+minPrice+' '+$t('message.promoter.user_cash_to_withdraw') "
                                    v-model="post.money"/>
                        </div>
                    </div>
                    <div class="tip">{{$t('message.promoter.user_cash_current_commission')}}: {{ commissionCount }}</div>
                    <div class="bnt bg-color-red" @click="submitted">{{$t('message.promoter.user_cash_withdraw')}}</div>
                </div>
            </div>
            <div :hidden="currentTab !== 1" class="list">
                <div class="item acea-row row-between-wrapper">
                    <div class="name">{{$t('message.promoter.user_cash_withdraw')}}</div>
                    <div class="input">
                        <input :placeholder="$t('message.promoter.user_cash_minimum')+' '+minPrice+' '+$t('message.promoter.user_cash_to_withdraw')" v-model="post.money"/>
                    </div>
                </div>
                <div class="tip">{{$t('message.promoter.user_cash_current_commission')}}: {{ commissionCount }}</div>
                <div class="bnt bg-color-red" @click="submitted">{{$t('message.promoter.user_cash_withdraw')}}</div>
            </div>
            <div :hidden="currentTab !== 2" class="list">
                <div class="item acea-row row-between-wrapper">
                    <div class="name">{{$t('message.promoter.user_cash_account')}}</div>
                    <div class="input">
                        <input :placeholder="$t('message.promoter.user_cash_account_pla')" v-model="post.name"/>
                    </div>
                </div>
                <div class="item acea-row row-between-wrapper">
                    <div class="name">{{$t('message.promoter.user_cash_account')}}</div>
                    <div class="input">
                        <input :placeholder="$t('message.promoter.user_cash_minimum')+' '+minPrice+' '+$t('message.promoter.user_cash_to_withdraw')" v-model="post.money"/>
                    </div>
                </div>
                <div class="tip">{{$t('message.promoter.user_cash_current_withdrawal')}}: {{ commissionCount }}</div>
                <div class="bnt bg-color-red" @click="submitted">{{$t('message.promoter.user_cash_withdraw')}}</div>
            </div>
        </div>
    </div>
</template>
<script>
    import {getBank, postCashInfo} from "../../../api/user";
    import {required} from "@utils/validate";
    import {validatorDefaultCatch} from "@utils/dialog";
    import navTitle from "@components/navTitle";

    export default {
        name: "UserCash",
        components: {navTitle},
        props: {},
        watch: {
            cashId(n) {
                let list = this.cashList;
                list.forEach(item => {
                    if (item.id === n) {
                        this.cashId = item.id;
                        this.cashUserName = item.type;
                        this.post.bank_account = item.bank_account;
                        this.post.real_name = item.bank_account_name;
                    }else {
                        this.cashId = ''
                        this.cashUserName = ''
                        this.post.bank_account = ''
                        this.post.real_name = ''
                    }
                });
            }
        },
        data: function () {
            return {
                navList: [
                    {name: this.$t('message.promoter.user_cash_to_e_wallet'), type: "BANKS", icon: "icon-yinhangqia"},
                    // { name: "提现到银行卡", type: "bank", icon: "icon-yinhangqia" },
                    {name: this.$t('message.promoter.user_cash_to_balance'), type: "balance", icon: "icon-weixin2"}
                ],
                cashList: [],
                cashId: "",
                cashUserName: "",
                showTips: "",
                post: {
                    real_name: "",
                    extract_type: "",
                    bank_account: "",
                    money: "",
                    ifsc: "",
                    upi: "",
                },
                currentTab: 1,
                minPrice: 0,
                // banks: [],
                commissionCount: 0
            };
        },
        mounted: function () {
            this.getBank();
            // this.swichNav(1,{name: this.$t('message.promoter.user_cash_to_balance'), type: "balance", icon: "icon-weixin2"});
        },
        methods: {
            swichNav: function (index, item) {
                this.currentTab = index;
                this.post.extract_type = item.type;
            },
            getExtractType: function (e) {
                if (e.target.value === "") {
                    this.cashUserName = ""
                    this.post.extract_type = ""
                    this.post.bank_account = ""
                    this.post.real_name = ""
                } else {
                    for (let i = 0; i < this.cashList.length; i++) {
                        if (this.cashList[i].id === e.target.value) {
                            this.cashUserName = this.cashList[i].type
                            this.post.bank_account = this.cashList[i].bank_account
                            this.post.extract_type = this.cashList[i].type
                        }
                    }
                }
            },
            getBank: function () {
                let that = this;
                this.$dialog.loading.open("Loading...");
                getBank().then(
                    res => {
                        this.$dialog.loading.close();
                        // that.banks = res.data.extractBank;
                        that.minPrice = res.data.minPrice;
                        that.commissionCount = res.data.commissionCount;
                        that.cashList = res.data.my_cash;
                        let cashList = res.data.my_cash;

                        // for (let i = 0; i < cashList.length; i++) {
                            /*if (cashList[i].type === 'PAYOK') {
                                that.post.bank_account = res.data.my_cash[i].bank_account;
                                // that.post.ifsc = res.data.my_cash[i].ifsc;
                                that.post.real_name = res.data.my_cash[i].account;
                            } else {
                                that.post.bank_account = '';
                                // that.post.upi = res.data.my_cash[i].upi;
                                that.post.real_name = res.data.my_cash[i].account;
                            }*/
                        // }

                        if (cashList.length > 0) {
                            this.showTips = "false";
                        } else {
                            this.showTips = "true";
                        }
                    },
                    function (err) {
                        this.$dialog.loading.close();
                        that.$dialog.message(err.msg);
                    }
                );
            },
            async submitted() {
                let money = this.post.money,
                    cashId = this.cashId,
                    that = this;
                if (
                    parseFloat(money) > parseFloat(that.commissionCount) ||
                    parseFloat(that.commissionCount) == 0
                )
                    return that.$dialog.message(this.$t('message.promoter.user_cash_insufficient_balance'));
                if (parseFloat(money) < parseFloat(that.minPrice))
                    return that.$dialog.message(this.$t('message.promoter.user_cash_minimum')+" " + that.minPrice + " "+this.$t('message.promoter.user_cash_to_withdraw'));
                switch (that.post.extract_type) {
                    case "balance":
                        try {
                            await this.$validator({
                                money: [required(required.message("Withdrawal amount"))]
                            }).validate({money});
                            let save = {
                                extract_type: that.post.extract_type,
                                money: money
                            };
                            that.save(save);
                        } catch (e) {
                            return validatorDefaultCatch(e);
                        }
                        break;
                    default:
                        that.save({
                            name: that.post.real_name,
                            extract_type: that.post.extract_type,
                            cash_id: cashId,
                            money: money
                        });
                        break;
                }
            },
            save: function (info) {
                // console.log(info)
                // return
                if (info.extract_type === "") {
                    return this.$dialog.error(this.$t('message.promoter.user_cash_select_account'))
                }
                if (info.money === "") {
                    return this.$dialog.error(this.$t('message.promoter.user_cash_data_format'))
                }
                postCashInfo(info).then(
                    res => {
                        this.$dialog.message(res.msg);
                        this.$router.push({path: "/user/audit"});
                    },
                    error => {
                        this.$dialog.message(error.msg);
                    }
                );
            }
        }
    };
</script>
